/**
 * API Service Configuration
 * Centralized API configuration with environment-based URL management
 */
import { getSdaApiBaseUrl } from './platformGateway';

// API endpoints configuration - multi-tenant endpoints
const apiConfig = {
  baseUrl: (process.env.REACT_APP_API_BASE_URL || '').trim() || getSdaApiBaseUrl(),
  endpoints: {
    // Auth endpoints
    auth: '/auth/login',
    login: '/auth/login',
    logout: '/auth/logout',
    
    // Tenant endpoints
    tenants: '/tenants',
    tenant: (id) => `/tenants/${id}`,
    tenantFeatures: (id) => `/tenants/${id}/features`,
    
    // User endpoints
    users: '/users',
    user: (id) => `/users/${id}`,
    userRoles: (id) => `/users/${id}/roles`,
    
    // Dashboard endpoints
    dashboards: '/dashboards',
    dashboard: (id) => `/dashboards/${id}`,
    dashboardWidgets: (id) => `/dashboards/${id}/widgets`,
    dashboardShare: (id) => `/dashboards/${id}/share`,
    sharedDashboards: '/dashboards/shared',
    dashboardFolders: (id) => `/dashboards/${id}/folders`,
    dashboardFolderRemove: (id, folderId) => `/dashboards/${id}/folders/${folderId}`,

    // Folder endpoints
    folder: '/folder',
    folderMove: '/folder/move',
    
    // Job/Upload endpoints
    jobs: '/jobs',
    job: (id) => `/jobs/${id}`,
    jobUpload: '/jobs/upload',
    jobPreview: (id) => `/jobs/${id}/preview`,
    
    // Widget endpoints
    widgets: '/widgets',
    widget: (id) => `/widgets/${id}`,
    widgetById: (id) => `/widgets/by-id/${id}`,
    widgetExecute: (id) => `/widgets/${id}/execute`,
    
    // Filter endpoints
    filters: '/filters',
    filter: (id) => `/filters/${id}`,
    jobFilters: (jobId) => `/filters/job/${jobId}`,
    
    // Analytics endpoints
    analytics: '/analytics',
    analyticsUsage: '/analytics/usage',
    analyticsPopular: '/analytics/popular',
    
    // Feature flags
    features: '/features',
    featureCheck: (feature) => `/features/${feature}`,
    
    // Sharing endpoints
    sharing: '/sharing',
    shareAccess: (id) => `/sharing/${id}/access`,
  },
};

// Helper function to get full URL for an endpoint
export const getApiUrl = (endpointName, ...params) => {
  const endpoint = apiConfig.endpoints[endpointName];
  
  if (!endpoint) {
    console.error(`Invalid endpoint: ${endpointName}`);
    throw new Error(`Invalid endpoint: ${endpointName}`);
  }
  
  // If endpoint is a function, call it with params
  const path = typeof endpoint === 'function' ? endpoint(...params) : endpoint;
  
  return `${apiConfig.baseUrl}${path}`;
};

// Export the base URL for direct use in components
export const getApiBaseUrl = () => {
  return apiConfig.baseUrl;
};

export default apiConfig;





